import ReactECharts from 'echarts-for-react';

function MenuPerEstab(props) {
    const { establishments, menus } = props
    const menusPerEstab = establishments.map(establishment => {
        const menuCount = menus.filter(menu => menu.establishment === establishment._id).length;
        return { value: menuCount, name: establishment.name };
    });

    const option = {
        title: {
            text: "Acticles par menu",
            textStyle: {
                color: 'black'
            },
            left: '50%',
            top: '10%',
            textAlign: 'center'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            bottom: 10,
            left: 'center'
        },
        series: [
            {
                name: 'Menus Per Establishment',
                type: 'pie',
                radius: ['40%', '70%'],
                center: ['50%', '70%'],
                startAngle: 180,
                endAngle: 360,
                data: menusPerEstab
            }
        ]
    };

    return (
        <div className="card" style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}>
             < ReactECharts option = { option } style={{ height: "300px", width: "100%" }}/>
        </div>
    );
}

export default MenuPerEstab;
